import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const problems = [{
  tag: '😩 Problème n° 1',
  title: '« Je m’ennuie ! » — encore et encore',
  text: 'Même avec une chambre remplie de jouets. Même juste après avoir acheté quelque chose de nouveau. Le cycle de l’ennui ne s’arrête jamais et vous manquez d’idées.',
  img: 'https://cdn.magicpatterns.com/uploads/ihjE7DKY1ufhoEJhsEe429/IMG_1064.webp',
  alt: 'Jeune enfant qui pleure à côté de jouets',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}, {
  tag: '📱 Problème n° 2',
  title: 'Les écrans. Toute la journée. Tous les jours.',
  text: 'Vous lui donnez une tablette « juste une minute » et, deux heures plus tard, il y est encore collé. Rien ne l’absorbe comme un écran — et vous détestez ça.',
  img: 'https://cdn.magicpatterns.com/uploads/iF8QAP4AAhfEAASdSCwhT5/IMG_1063.webp',
  alt: 'Garçon frustré regardant une tablette',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '😤 Problème n° 3',
  title: 'Vous avez tout essayé — rien ne dure',
  text: 'Kits créatifs, puzzles, activités en plein air… cela tient un après-midi. Vous dépensez de l’argent et de l’énergie, mais rien ne retient son attention plus d’une journée.',
  img: 'https://cdn.magicpatterns.com/uploads/wLtfrSPqS9mi15yuLtP3pw/IMG_1062.webp',
  alt: 'Deux garçons cachés derrière leurs téléphones',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '😭 Problème n° 4',
  title: 'La crise quand l’écran disparaît',
  text: 'Chaque fois que vous limitez le temps d’écran, cela devient une bataille. Pleurs, colères, négociations. Vous avez l’impression d’être le méchant, alors que vous voulez seulement ce qu’il y a de mieux pour lui.',
  img: 'https://cdn.magicpatterns.com/uploads/by9pMNhj1jGZXhdizermvD/IMG_1065.webp',
  alt: 'Fille qui pleure près d’un ours en peluche',
  tone: 'bg-brand-light',
  tagTone: 'bg-brand/15 text-brand'
}];
export function Problems() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-143" data-mp="kveprmupoa3l">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-144" data-mp="kttsvqkxcf2k">
        <SectionHeading eyebrow="Cela vous parle ?" title="Vous connaissez ce sentiment ?" subtitle="Tous les parents le connaissent. Vous voulez éloigner vos enfants des écrans et les occuper avec quelque chose de concret — mais rien ne semble retenir leur attention longtemps." data-id="element-145" data-mp="fw206ucggoxb" />
        <div className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-146" data-mp="16e0tynu40c8">
          {problems.map((p, i) => <motion.article key={p.tag} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${p.tone}`} data-id="element-147" data-mp="3tcj5rpbgg75y" data-mpi={i}>
              <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-148" data-mp="3e8ggkxl9ptym">
                <img src={p.img} alt={p.alt} className="h-full w-full object-cover" data-id="element-149" data-mp="3j7t29f0ekuzm" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-150" data-mp="2llvp7x4slhv2">
                <span className={`mb-3 w-fit rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${p.tagTone}`} data-id="element-151" data-mp="2qicg2z3dmabu">
                  {p.tag}
                </span>
                <h3 className="font-display text-xl font-bold text-ink" data-id="element-152" data-mp="308owcf45rhc6">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-153" data-mp="22ucmlreok5tk">
                  {p.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}